import { ChessTermType, TermAction } from "@chesshotel/types";
export const chessTermScore = {
    [ChessTermType.OFFER_TRADE]: 3,
    [ChessTermType.OFFER_TRADE_SAME_PIECE]: 3,
    [ChessTermType.KICK_PIECE]: 6,
    [ChessTermType.TEMPO]: 6,
    [ChessTermType.THREATEN_PIECE]: 6,
    [ChessTermType.THREATEN_TRADE]: 5,
    [ChessTermType.THREATEN_CHECKMATE]: 10,
    [ChessTermType.DOUBLE_PAWN]: 5,
    [ChessTermType.FORCE_DOUBLE_PAWN]: 7,
    [ChessTermType.BACKWARD_PAWN]: 6,
    [ChessTermType.PAWN_CHAIN]: 4,
    [ChessTermType.ATTACK_PAWN_CHAIN]: 5,
    [ChessTermType.BLOCKADE]: 5,
    [ChessTermType.ISOLATED_PAWN]: 6,
    [ChessTermType.FORCE_ISOLATE_PAWN]: 5,
    [ChessTermType.CONNECT_PAWN]: 6,
    [ChessTermType.OFFER_TRADE_CONNECT_PAWN]: 5,
    [ChessTermType.PASSED_PAWN]: 6,
    [ChessTermType.OFFER_TRADE_PASSED_PAWN]: 6,
    [ChessTermType.PROMOTION]: 7,
    [ChessTermType.BLOCK]: 6,
    [ChessTermType.DEFEND]: 6,
    [ChessTermType.MOVE_TO_SAFETY]: 6,
    [ChessTermType.IN_CHECK_MOVE_TO_SAFETY]: 6,
    [ChessTermType.IN_CHECK_BLOCK]: 6,
    [ChessTermType.IN_CHECK_ESCAPE]: 6,
    [ChessTermType.COUNTER_ATTACK]: 7,
    [ChessTermType.DEFEND_MATE]: 10,
    [ChessTermType.DEFEND_MATE_CHECK]: 10,
    [ChessTermType.CENTER_CONTROL]: 3,
    [ChessTermType.KING_SAFETY]: 3,
    [ChessTermType.BAD_KING_SAFETY]: 3,
    [ChessTermType.OUTPOST]: 6,
    [ChessTermType.PIECE_ACTIVITY]: 2,
    [ChessTermType.CASTLE]: 6,
    [ChessTermType.CAN_CASTLE]: 6,
    [ChessTermType.PREVENT_CASTLING]: 7,
    [ChessTermType.OPEN_FILE]: 6,
    [ChessTermType.OPEN_DIAGONAL]: 5,
    [ChessTermType.CHALLENGE_OPEN_FILE]: 6,
    [ChessTermType.CHALLENGE_OPEN_DIAGONAL]: 5,
    [ChessTermType.SACRIFICE]: 7,
    [ChessTermType.UNDEFENDED_SACRIFICE]: 7,
    [ChessTermType.IGNORE_THREAT]: 7,
    [ChessTermType.CONNECT_ROOKS]: 6,
    [ChessTermType.CONNECT_ROOKS_BACK_RANK]: 6,
    [ChessTermType.CONNECT_QUEEN_AND_BISHOP]: 6,
    [ChessTermType.BOOK_MOVE]: 5,
    [ChessTermType.DEVELOP_QUEEN_EARLY]: 5,
    [ChessTermType.DEVELOPMENT]: 5,
    [ChessTermType.ACTIVATE_ROOK]: 4,
    [ChessTermType.ACTIVATE_QUEEN]: 4,
    [ChessTermType.MOVE_DEVELOPED_PIECE]: 5,
    [ChessTermType.BAD_OPENING_MOVE]: 4,
    [ChessTermType.CHECKMATE]: 12,
    [ChessTermType.FOLLOW_CHECKMATE]: 10,
    [ChessTermType.DRAW]: 7,
    [ChessTermType.STALE_MATE]: 8,
    [ChessTermType.TRADE]: 6,
    [ChessTermType.BAD_TRADE]: 7,
    [ChessTermType.BAD_EQUAL_TRADE]: 6.5,
    [ChessTermType.RETAKE]: 6,
    [ChessTermType.TAKES_BACK]: 6,
    [ChessTermType.DIRECT_MATERIAL_WIN]: 7.5,
    [ChessTermType.HANGING]: 7.5,
    [ChessTermType.MATERIAL_WIN]: 7.5,
    [ChessTermType.TACTIC]: 8,
    [ChessTermType.FORK]: 8,
    [ChessTermType.PIN]: 7,
    [ChessTermType.SKEWER]: 8,
    [ChessTermType.DOUBLE_ATTACK]: 8,
    [ChessTermType.DISCOVERED_ATTACK]: 8,
    [ChessTermType.UNPIN]: 5,
    [ChessTermType.REMOVE_DEFENDER]: 8,
    [ChessTermType.OVERLOADING]: 7,
    [ChessTermType.DEFLECTION]: 7,
    [ChessTermType.TRAPPED_PIECE]: 8,
    [ChessTermType.INITIATIVE_CHANGE]: 4,
    [ChessTermType.EQUAL_TO_ADVANTAGE]: 4,
    [ChessTermType.ADVANTAGE_TO_EQUAL]: 4,
    [ChessTermType.NONE]: 1,
    [ChessTermType.CHECK]: 6,
    [ChessTermType.TIME_UP]: 0,
    [ChessTermType.THREEFOLD_REPETITION]: 0,
};
export const termActionPriority = {
    [TermAction.BETTER_WAY]: 3,
    [TermAction.MISS]: 2,
    [TermAction.ALLOW]: 1,
    [TermAction.PERFORM]: 2,
    [TermAction.ALLOW_THREAT]: 1,
    [TermAction.MISS_THREAT]: 1,
    [TermAction.PERFORM_THREAT]: 1,
    [TermAction.CREATE]: 1,
    [TermAction.POSPONE]: 1,
    [TermAction.ALLOW_UNDEFENDED]: 1,
};
//# sourceMappingURL=chessTermScore.js.map